import { useUser } from "@clerk/nextjs";
import { datadogRum } from "@datadog/browser-rum";
import {
  DATADOG_RUM_APPLICATION_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  DATADOG_RUM_SERVICE,
  RELEASE_TAG,
} from "constants/config";
import { useEffect } from "react";

// Datadog configuration based on domain
const getDatadogEnv = () => {
  if (typeof window === "undefined") return null;

  const hostname = window.location.hostname;
  const isProduction = hostname === "consensus.app";
  const isStaging = hostname === "staging.consensus.app";

  const isDev = hostname === "dev.consensus.app";

  if (isProduction) return "prod";
  if (isStaging) return "staging";
  if (isDev) return "dev";

  // For local development
  return "local-dev";
};

export const useDatadogInit = () => {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (
      DATADOG_RUM_APPLICATION_ID &&
      DATADOG_RUM_CLIENT_TOKEN &&
      DATADOG_RUM_SERVICE
    ) {
      const env = getDatadogEnv();

      datadogRum.init({
        applicationId: DATADOG_RUM_APPLICATION_ID,
        clientToken: DATADOG_RUM_CLIENT_TOKEN,
        site: "us3.datadoghq.com",
        service: DATADOG_RUM_SERVICE,
        env: env,
        version: RELEASE_TAG,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 10,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
      });
    }
  }, []);

  // Set user context when user data is available
  useEffect(() => {
    if (isLoaded && user && datadogRum) {
      datadogRum.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        name: user.fullName || user.firstName || undefined,
      });
    } else if (isLoaded && !user && datadogRum) {
      // Clear user context if user logs out by setting anonymous user
      datadogRum.clearUser();
    }
  }, [isLoaded, user]);
};
